{
  "it": {
    "subscription": {
      "customers": {
        "announcement": {
          "description": "Riceva una notifica quando vengono pubblicate novità.",
          "label": "Novità"
        },
        "question": {
          "description": "Riceva una notifica quando vengono aggiunte nuove domande nella sezione FAQ.",
          "label": "FAQ"
        }
      },
      "employees": {
        "aftercare": {
          "description": "Riceva notifiche relative alle segnalazioni e al post-vendita.",
          "label": "Post-vendita"
        },
        "announcement": {
          "description": "Riceva una notifica quando vengono pubblicate novità.",
          "label": "Novità"
        },
        "decision": {
          "description": "Riceva notifiche relative alle decisioni.",
          "label": "Decisioni"
        },
        "document": {
          "description": "Riceva una notifica quando vengono caricati nuovi documenti.",
          "employee_create": {
            "description": "Riceva una notifica quando altri dipendenti caricano documenti.",
            "label": "Documenti dei colleghi"
          },
          "label": "Documenti"
        },
        "email_conversation": {
          "description": "Riceva una notifica quando le email vengono inoltrate ai Suoi progetti Ziggu.",
          "label": "Inoltro email"
        },
        "export": {
          "description": "Riceva una notifica quando vengono generate esportazioni.",
          "label": "Esportazioni"
        },
        "question": {
          "description": "Riceva una notifica quando vengono aggiunte nuove domande nella sezione FAQ.",
          "label": "FAQ"
        },
        "survey": {
          "description": "Riceva notifiche relative ai questionari.",
          "label": "Questionari"
        },
        "ticket": {
          "description": "Riceva notifiche relative alle conversazioni.",
          "label": "Conversazioni"
        },
        "todo": {
          "description": "Riceva una notifica quando viene assegnato come responsabile di un'attività.",
          "label": "Assegnazioni di attività"
        }
      },
      "labels": {
        "email_preferences": "Le mie preferenze di notifica via email",
        "general_preferences": "Le mie preferenze di notifica",
        "receiveEmailNotificationsAbout": "Ricevere notifiche email"
      }
    }
  }
}
